version1 = [
    {
        "name":'全部科室',
        "type": 'hierarchy',
        "submenu": [{
            "name": "全部科室",
            "value": "全部科室"
        }]
    },
    {
        "name":'全部职称',
        "type": 'hierarchy',
        "submenu": [
            {
                "name": "全部职称",
                "value": "全部职称"
            },
            {
                "name": "主治医师",
                "value": "主治医师"
            },
            {
                "name": "副主任医师",
                "value": "副主任医师"
            },
            {
                "name": "科室专家",
                "value": "科室专家"
            },
            {
                "name": "门诊医生",
                "value": "门诊医生"
            }
        ]
    },
]

version2 =  [
    {
        "name":'全部科室',
        "type": 'hierarchy',
        "submenu": [{
            "name": "全部科室",
            "value": "全部科室"
        }]
    }
]


loginMedicalservices = [
    {
        name: '我的订单',
        itemImage: [
            {
                name: '挂号订单',
                imgIcon: 'http://file.aihuihc.com/patient/patientImages/images/login/registerOrder.png'
            },
            {
                name: '缴费订单',
                imgIcon: 'http://file.aihuihc.com/patient/patientImages/images/login/payOrder.png'
            },
            {
                name: '咨询订单',
                imgIcon: 'http://file.aihuihc.com/patient/patientImages/images/login/consultingOrder.png'
            },
            {
                name: '我的消息',
                imgIcon: 'http://file.aihuihc.com/patient/patientImages/images/login/myNews.png'
            },
        ]
    },
    {
        name: '常用工具',
        itemImage: [
            {
                name: '健康卡',
                imgIcon: 'http://file.aihuihc.com/patient/patientImages/images/login/healthyCard.png'
            },
            {
                name: '设置',
                imgIcon: 'http://file.aihuihc.com/patient/patientImages/images/login/setting.png'
            }
        ]
    }
]

homeSkeleton = {
    videoFour: [
        {
            titleName: '免疫力如何提高？',
            pagePath: 'http://file.aihuihc.com/patient/patientImages/images/newHome/test1.mp4'
        },
        {
            titleName: '头疼该怎么办？',
            pagePath: 'http://baobab.kaiyanapp.com/api/v1/playUrl?vid=196464&resourceType=video&editionType=default&source=aliyun&playUrlType=url_oss'
        },
        {
            titleName: '免疫力如何提高？',
            pagePath: 'http://baobab.kaiyanapp.com/api/v1/playUrl?vid=169401&resourceType=video&editionType=default&source=aliyun&playUrlType=url_oss'
        },
        {
            titleName: '头疼该怎么办？',
            pagePath: 'https://img.cdn.aliyun.dcloud.net.cn/guide/uniapp/%E7%AC%AC1%E8%AE%B2%EF%BC%88uni-app%E4%BA%A7%E5%93%81%E4%BB%8B%E7%BB%8D%EF%BC%89-%20DCloud%E5%AE%98%E6%96%B9%E8%A7%86%E9%A2%91%E6%95%99%E7%A8%8B@20200317.mp4'
        }
    ],
    menuBarList: [
        {
            grade: 1,
            name: '预约挂号',
            imageUrl: ''
        },
        {
            grade: 1,
            name: '在线就诊',
            imageUrl: ''
        },
        {
            grade: 2,
            name: '体检报告',
            imageUrl: ''
        },
        {
            grade: 2,
            name: '住院服务',
            imageUrl: ''
        },
        {
            grade: 2,
            name: '检查检验报告',
            imageUrl: ''
        },
        {
            grade: 2,
            name: '门诊病历',
            imageUrl: ''
        },
        {
            grade: 2,
            name: '远程会诊',
            imageUrl: ''
        }
    ]
}

module.exports = {
    version1,
    version2,
    homeSkeleton,
    loginMedicalservices
}



// WEBPACK FOOTER //
// ./libs/common/version1.js